import MasterBusiness from "./Business";

export default MasterBusiness;
